import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import 'chart.js/auto';
import { Bar, Pie, getElementAtEvent } from 'react-chartjs-2';

import EventsPanel from '../../../components/shared/EventsPanel';

import { spaceAndCapitalize } from '../../../utilities/Forms.js'

import SlidingPane from "../../../components/shared/ScrollableSlidingPane";

class FeedbackAnswer extends Component {
  static QUESTION_TYPES_WITH_ANSWERS = {
    "boolean": [
      "yes",
      "no",
      "na"
    ],
    "stars": [
      "one_star",
      "two_stars",
      "three_stars",
      "four_stars",
      "five_stars",
    ],
    "smileys": [
      "very_unhappy",
      "unhappy",
      "neutral",
      "happy",
      "very_happy",
    ],
    "thumbs": [
      "two_thumbs_down",
      "one_thumb_down",
      "no_thumbs_up",
      "one_thumb_up",
      "two_thumbs_up",
    ],
    "net_promoter": [
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "ten",
    ],
    "text": [
      "text"
    ]
  };

  static answersByIndex(answer) {
    return answer.type === "multi_select" ? Object.keys(answer.options) :  FeedbackAnswer.QUESTION_TYPES_WITH_ANSWERS[answer.type]
  }

  constructor(props) {
    super(props);

    this.barGraph = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.openPanel = this.openPanel.bind(this);
  }

  handleClick(event) {
    // do not try to open events panel when charts are not being clicked
    if (getElementAtEvent(this.barGraph.current, event)[0] === undefined) {
      return
    }

    const element = getElementAtEvent(this.barGraph.current, event)[0]
    const index = this.props.answer.type === "boolean" || this.props.answer.type === "net_promoter" ? element.index : element.datasetIndex
    this.openPanel(index)
  }

  openPanel(index) {
    let panelTitleOverride;

    if (this.props.answer.quantity === 4 && index > 1) {
      panelTitleOverride = FeedbackAnswer.answersByIndex(this.props.answer)[index]
      index++
    }

    let type = FeedbackAnswer.answersByIndex(this.props.answer)[index]

    this.setState({
      infoPanel: true,
      panelTitleOverride: panelTitleOverride,
      type: type
    })

    this.props.history.push(`/analysis/feedback/feedback_answer/${this.props.index}/${panelTitleOverride || type}${this.props.location.search}`)
  }

  state = {
    answers: [],
    infoPanel: false,
    type: null,
    questionIndex: null,
  };

  starsAnswer() {
    const data = {
      labels: ["results"],
      datasets: [{
        label: "1 Star",
        data: [this.props.answer.one.length],
        backgroundColor: '#ce5252',
      }, {
        label: "2 Stars",
        data: [this.props.answer.two.length],
        backgroundColor: '#f29e32',
      }, {
        label: "3 Stars",
        data: [this.props.answer.three.length],
        backgroundColor: '#eee622',
      }, {
        label: this.props.answer.quantity === 4 ? "3 Stars" : "4 Stars",
        data: [this.props.answer.four.length],
        backgroundColor: '#cbee22',
      }, {
        label: this.props.answer.quantity === 4 ? "4 Stars" : "5 Stars",
        data: [this.props.answer.five.length],
        backgroundColor: '#22ee80'
      }]
    }

    if (this.props.answer.quantity === 4) {
      data.datasets.splice(2, 1)
    }

    const options = {
      legend: {
        position: 'top',
      },
      scales: {
        yAxes: {
          ticks: {
            beginAtZero: true
          }
        }
      }
    }

    return (
      <div className="widget" key={this.props.answer.question}>
        <h3>{this.props.answer.question}</h3>
        <Bar className="link" data={data} width={500} height={300} options={options} ref={this.barGraph} onClick={this.handleClick} />
      </div>
    );
  }

  smileysAnswer() {
    const data = {
      labels: ["results"],
      datasets: [{
        label: "Very unhappy",
        data: [this.props.answer.very_unhappy.length],
        backgroundColor: '#ce5252',
      }, {
        label: "Unhappy",
        data: [this.props.answer.unhappy.length],
        backgroundColor: '#f29e32',
      }, {
        label: "Neutral",
        data: [this.props.answer.neutral.length],
        backgroundColor: '#eee622',
      }, {
        label: "Happy",
        data: [this.props.answer.happy.length],
        backgroundColor: '#cbee22',
      }, {
        label: "Very happy",
        data: [this.props.answer.very_happy.length],
        backgroundColor: '#22ee80',
      }]
    }

    if (this.props.answer.quantity === 4) {
      data.datasets.splice(2, 1)
    }

    const options = {
      legend: {
        position: 'top',
      },
      scales: {
        yAxes: {
          ticks: {
            beginAtZero: true
          }
        }
      }
    }

    return (
      <div className="widget" key={this.props.answer.question}>
        <h3>{this.props.answer.question}</h3>
        <Bar className="link" data={data} width={500} height={300} options={options} ref={this.barGraph} onClick={this.handleClick} />
      </div>
    );
  }

  thumbsAnswer() {
    const data = {
      labels: ["results"],
      datasets: [{
        label: "Two thumbs down",
        data: [this.props.answer.two_thumbs_down.length],
        backgroundColor: '#ce5252',
      }, {
        label: "One thumb down",
        data: [this.props.answer.one_thumb_down.length],
        backgroundColor: '#f29e32',
      }, {
        label: "No thumbs up",
        data: [this.props.answer.no_thumbs_up.length],
        backgroundColor: '#eee622',
      }, {
        label: "One thumb up",
        data: [this.props.answer.one_thumb_up.length],
        backgroundColor: '#cbee22',
      }, {
        label: "Two thumbs up",
        data: [this.props.answer.two_thumbs_up.length],
        backgroundColor: '#22ee80',
      }]
    }

    if (this.props.answer.quantity === 4) {
      data.datasets.splice(2, 1)
    }

    const options = {
      legend: {
        position: 'top',
      },
      scales: {
        yAxes: {
          ticks: {
            beginAtZero: true
          }
        }
      }
    }

    return (
      <div className="widget" key={this.props.answer.question}>
        <h3>{this.props.answer.question}</h3>
        <Bar className="link" data={data} width={500} height={300} options={options} ref={this.barGraph} onClick={this.handleClick} />
      </div>
    );
  }

  netPromoterAnswer() {
    const data = {
      labels: ["0","1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      datasets: [
        {
          label: "Negative",
          backgroundColor: '#ce5252',
          data: [
            this.props.answer.zero.length,
            this.props.answer.one.length,
            this.props.answer.two.length,
            this.props.answer.three.length,
            this.props.answer.four.length,
            this.props.answer.five.length,
            this.props.answer.six.length,
            0,
            0,
            0,
            0
          ]
        },
        {
          label: "Neutral",
          backgroundColor: '#eee622',
          data: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            this.props.answer.seven.length,
            this.props.answer.eight.length,
            0,
            0
          ]
        },
        {
          label: "Positive",
          backgroundColor: '#22ee80',
          data: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            this.props.answer.nine.length,
            this.props.answer.ten.length
          ]
        }
      ]
    }

    const options = {
      legend: {
        position: 'top',
      },
      scales: {
        yAxes: {
          ticks: {
            beginAtZero: true
          }
        },
        xAxes: {
          stacked: true,
          title: {
            display: true,
            text: 'Responses'
          }
        }
      }
    }

    return (
      <div className="widget" key={this.props.answer.question}>
        <h3>{this.props.answer.question}</h3>

        <Bar className="link" data={data} width={500} height={300} options={options} ref={this.barGraph} onClick={this.handleClick}/>
      </div>
    );
  }

  booleanAnswer() {
    const data = {
      labels: ['No', 'N/A', 'Yes'],
      datasets: [{
        data: [
          this.props.answer.no.length,
          this.props.answer.na.length,
          this.props.answer.yes.length
        ],
        backgroundColor: ['#ce5252', '#eee622', '#22ee80']
      }],
    }

    if (this.props.answer.quantity === 2 && this.props.answer.na.length === 0) {
      data.labels.splice(1, 1)
      data.datasets[0].data.splice(1, 1)
      data.datasets[0].backgroundColor.splice(1, 1)
    }

    const options = {}

    return (
      <div className="widget" key={this.props.answer.question}>
        <h3>{this.props.answer.question}</h3>
        <Pie className="link" data={data} width={500} height={300} options={options} ref={this.barGraph} onClick={this.handleClick} />
      </div>
    );
  }

  multiSelectAnswer() {
    const datasets = []
    let index = 0
    for (let option in this.props.answer.options) {
      datasets.push({
        label: option,
        data: [this.props.answer.options[option].length],
        backgroundColor: this.findBackgroundColour(index++)
      })
    }
    const data = {
      labels: ["results"],
      datasets
    }

    const options = {
      legend: {
        position: 'top',
      },
      scales: {
        yAxes: {
          ticks: {
            beginAtZero: true
          }
        }
      }
    }

    return (
      <div className="widget" key={this.props.answer.question}>
        <h3>{this.props.answer.question}</h3>
        <Bar className="link" data={data} width={500} height={300} options={options} ref={this.barGraph} onClick={this.handleClick} />
      </div>
    );
  }

  findBackgroundColour(index) {
    const colours = [
      "#B80C09",
      "#FF8819",
      "#EEE622",
      "#22EE80",
      "#222AEE",
      "#8826BF",
      "#EE2290"
    ]

    return colours[index % colours.length]
  }

  unsupportedAnswer() {
    return (
      <div className="widget text-answer" key={this.props.answer.question}>
        <h3>{this.props.answer.question}</h3>
        <div>
          <p>No chart to show for {spaceAndCapitalize(this.props.answer.type)} question</p>
          <p>View <Link to={`/exports/feedback?question=${this.props.answer.question_id}`}>Export Feedback</Link> page instead</p>
        </div>
      </div>
    )
  }

  answerType() {
    switch(this.props.answer.type) {
      case "stars":
        return this.starsAnswer()
      case "smileys":
        return this.smileysAnswer()
      case "thumbs":
        return this.thumbsAnswer()
      case "boolean":
        return this.booleanAnswer()
      case "multi_select":
        return this.multiSelectAnswer()
      case "net_promoter":
        return this.netPromoterAnswer()
      default:
        // e.g. text
        return this.unsupportedAnswer()
    }
  }

  calculateEventIDs() {
    const { infoPanel, type } = this.state;

    if (!infoPanel || !type) {
      return
    }

    if (this.props.answer.type === "multi_select") {
      return this.props.answer.options[type]
    }

    return this.props.answer.type === "stars" ? this.props.answer[type.split("_")[0]] : this.props.answer[type]
  }

  render() {
    const { infoPanel, type, panelTitleOverride } = this.state;

    return (
      <>
       {this.answerType()}

        <SlidingPane isOpen={infoPanel} title={type && `${this.props.answer.question} - ${spaceAndCapitalize(panelTitleOverride || type)} Events`} width="70%"
          onRequestClose={() => {
            this.setState({
              infoPanel: false,
              type: null
            });
            this.props.history.push(`/analysis/feedback${this.props.location.search}`)
          }}>
          <EventsPanel event_ids={this.calculateEventIDs()}></EventsPanel>
        </SlidingPane>
      </>
    )
  }

  static getDerivedStateFromProps(props, state) {
    const validContext = parseInt(props.match.params.context) === props.index && (FeedbackAnswer.answersByIndex(props.answer).includes(props.match.params.context2))
    let type = props.match.params.context2;
    let panelTitleOverride;

    if (props.answer.type === "stars" && props.answer.quantity === 4) {
      if ("three_stars" === props.match.params.context2) {
        panelTitleOverride = "three_stars";
        type = "four_stars"
      }

      if ("four_stars" === props.match.params.context2) {
        panelTitleOverride = "four_stars"
        type = "five_stars"
      }
    }

    if (state.infoPanel === false && props.match.params.chart === "feedback_answer" && validContext) {
      return {
        infoPanel: true,
        type: type,
        panelTitleOverride: panelTitleOverride
      }
    }
    else if (state.infoPanel && (props.match.params.chart !== "feedback_answer" || validContext === false)) {
      return {
        infoPanel: false,
        type: null,
        panelTitleOverride: null
      }
    }
    // handle back/forward buttons
    if (props.history.action === "POP" && props.match.params.chart === "feedback_answer" && validContext) {
      return {
        infoPanel: true,
        type: type,
        panelTitleOverride: panelTitleOverride
      }
    }
    else if (props.history.action === "POP" && (props.match.params.chart !== "feedback_answer" || validContext === false)) {
      return {
        infoPanel: false,
        type: null,
        panelTitleOverride: null
      }
    }
    else {
      return null
    }
  }
}

export default withRouter(FeedbackAnswer);
